module.exports = __webpack_public_path__ + "static/img/h_23@2x.9e67f6c2.png";